module.exports = __webpack_public_path__ + "img/filter_big.29c563e9.svg";